import React from "react";

const ProductionIcon = (props) => {
    const {size, marked,style} = props;
    return(
        <svg 
            xmlns="http://www.w3.org/2000/svg"  
            viewBox="0 0 24 24" 
            width={size} 
            height={size}
            marked={marked}
            style={style}
        >
           <path 
            fill={marked===1 ? "black" : "black"}
            d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 10 8.8105469 L 6.7929688 12.017578 L 10 15.224609 L 11 14.224609 L 8.7929688 12.017578 L 11 9.8105469 L 10 8.8105469 z M 14 8.8105469 L 13 9.8105469 L 15.207031 12.017578 L 13 14.224609 L 14 15.224609 L 17.207031 12.017578 L 14 8.8105469 z"
            />   
        </svg>
    )
}

export default ProductionIcon;

